module.exports = __webpack_public_path__ + "img/Dawid Steposz.98b3144f.webp";